import React from "react";

const DiscussionContext = React.createContext({});

export default DiscussionContext
